import { type Action, crossActionTypes, loanActionTypes } from '@0xtorch/core'

type NormalizeChainActionEvidencesParameters = {
  readonly actions: readonly Action[]
}

/**
 * チェーン解析で生成された複数取引型 action の evidence を要確認状態へ統一する。
 *
 * @param actions - チェーン解析で生成された action の一覧。
 * @returns cross action または loan action の evidence を `none` にした一覧。
 */
export const normalizeChainActionEvidences = ({
  actions,
}: NormalizeChainActionEvidencesParameters): readonly Action[] =>
  actions.map((action) =>
    crossActionTypes.has(action.type) || loanActionTypes.has(action.type)
      ? { ...action, evidence: 'none' }
      : action,
  )
